import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  public fullyDisabled = true;

  public disabled = true;

  public isLocal = false;

  public isDev = false;

  // Disables elements of pricing & fees settings and fee-related criteria that are managed in MarketScan's console.
  // Setting to false will reenable the legacy pricing & fees pages.
  public marketScanEnabled = true;

  constructor() {
    this.disabled = ['prod', 'stage', 'feature', 'dev'].includes(environment.stage);
    this.isLocal = ['local'].includes(environment.stage);
    this.isDev = ['stage', 'feature', 'dev', 'local'].includes(environment.stage);
  }

  get getEnv() {
    return environment.stage;
  }
}
